export default __webpack_public_path__ + "static/media/About-us.dc4ccbb0.jpeg";